import { render, staticRenderFns } from "./immediatPayment.vue?vue&type=template&id=0b78369d&scoped=true&"
import script from "./immediatPayment.vue?vue&type=script&lang=ts&"
export * from "./immediatPayment.vue?vue&type=script&lang=ts&"
import style0 from "./immediatPayment.vue?vue&type=style&index=0&id=0b78369d&lang=less&scoped=true&"
import style1 from "./immediatPayment.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b78369d",
  null
  
)

component.options.__file = "immediatPayment.vue"
export default component.exports